(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["audio-player"] && !Shopify.designMode) return;
  try {
    const audio = document.querySelector('audio');

    const curTime = document.getElementById('ap_current_time');
    const durTime = document.getElementById('ap_duration');

    const calcTime =(secs) => {
        const mm = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const ss = seconds < 10 ? `0${seconds}` : `${seconds}`;

        return `${mm}:${ss}`;
    };

    const playPause = document.getElementById('ap_play_pause');
    const playButton = document.getElementById('play_button');
    const pauseButton = document.getElementById('pause_button');

    const seeker = document.getElementById('ap_seeker');

    const mute = document.getElementById('ap_audio');
    const volume = document.getElementById('ap_volume_slider');

    const muteOff = document.getElementById('mute_off_button');
    const muteOn = document.getElementById('mute_button');

    audio.onloadedmetadata = () => {
        curTime.innerHTML = calcTime(audio.currentTime);
        durTime.innerHTML = calcTime(audio.duration);
    };

    audio.ontimeupdate = () => {
        seeker.value = Math.floor(audio.currentTime);

        curTime.textContent = calcTime(seeker.value);

        if (audio.currentTime === audio.duration) {
            console.log('audio ended');

            pauseButton.classList.add('inactive');
            playButton.classList.remove('inactive');
            audio.currentTime = 0;

            curTime.innerHTML = audio.currentTime;
        }
    };

    playPause.addEventListener('click', () => {
        console.log('play pause toggle')

        if(audio.paused) {
            audio.play();
            playButton.classList.add('inactive');
            pauseButton.classList.remove('inactive');
        } else {
            audio.pause();
            pauseButton.classList.add('inactive');
            playButton.classList.remove('inactive');
        }
    });

    seeker.addEventListener('change', () => {
        console.log('seeking track');
        
        seeker.setAttribute('max', Math.floor(audio.duration));
        audio.currentTime = seeker.value;
    });

    mute.addEventListener('click', () => {
        console.log('mute toggle');
        
        if (audio.muted) {
            audio.muted = false;
            muteOff.classList.remove('inactive');
            muteOn.classList.add('inactive');
            volume.removeAttribute('disabled');
        } else {
            audio.muted = true;
            muteOn.classList.remove('inactive');
            muteOff.classList.add('inactive');
            volume.setAttribute('disabled', '');
        }
    });

    volume.addEventListener('change', () => {
        console.log('volume slider')
        
        audio.volume = volume.value / 100;
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-static"] && !Shopify.designMode) return;
  try {
    if (window.innerWidth >= 750) {
  const hero = document.getElementById("hero-img");

  // ONLY proceed if the hero-img exists on the current page
  if (hero) {
    const logo = document.getElementById("static-logo");
    const bars = document.getElementById("bars");
    const search = document.getElementById("search");
    const cart = document.getElementById("cart");

    // Pre-collect targets to avoid DOM lookups during scroll
    const containers = [logo, bars, search, cart].filter(Boolean);
    const nestedItems = containers.flatMap(c => [...c.querySelectorAll('path, a')]);
    
    let triggerPoint = 0;

    // Calculate the trigger point once (and on resize) to save CPU
    const updateDimensions = () => {
      triggerPoint = (hero.offsetTop + hero.offsetHeight) - 10;
    };

    const handleHeroColors = () => {
      const isAboveTrigger = window.pageYOffset <= triggerPoint;
      const targetColor = isAboveTrigger ? "#FFFEFE" : "";

      // Update container fills/colors
      containers.forEach(el => {
        el.style.fill = targetColor;
        el.style.color = targetColor;
      });

      // Update nested text and icons
      nestedItems.forEach(el => {
        const property = (el.tagName.toLowerCase() === 'a') ? 'color' : 'fill';
        el.style[property] = targetColor;
      });
    };

    // Listeners
    window.addEventListener('load', () => {
      updateDimensions();
      handleHeroColors();
    });

    window.addEventListener('resize', () => {
      updateDimensions();
      handleHeroColors();
    });

    // Use { passive: true } for maximum scroll performance
    window.addEventListener('scroll', handleHeroColors, { passive: true });
  }
}
  } catch(e) { console.error(e); }
})();

})();
